export default {
  test: {
    'hello': 'Hello'
  }
}
